const TEMPO = ['Quanto lancei essa semana?', 'Quais dias ficaram sem lançamento?', 'Lançar: ontem 3h no projeto…'];
const RELATORIOS = ['Receita por cliente no mês', 'Quem lançou menos de 30h?', 'Horas faturáveis × não faturáveis'];
const PROJETOS = ['Quais projetos estão em risco?', 'O que está atrasado comigo?', 'Resuma a semana do projeto para o cliente'];
const PROPOSTAS = ['Estime um apartamento de 120 m²', 'Quanto cobramos por m² em casas?', 'Quais projetos parecidos já fizemos?'];

const SECOES_PROJETOS = [
  'activities', 'my-activities', 'activities-strategic', 'activities-control', 'activities-calendar',
  'projects', 'tasks', 'tasks-unified', 'tasks-summary', 'tasks-insights', 'today', 'upcoming', 'overdue',
];

export const TELA_LABEL: Record<'time' | 'reports' | 'activities-strategic' | 'price-simulator', string> = {
  time: 'Tempo', reports: 'Relatórios', 'activities-strategic': 'Gantt', 'price-simulator': 'Simulador',
};

// Cabeçalho e sugestões do painel conforme o bloco aberto.
export function panelContext(section: string, isAdmin: boolean): { titulo: string; sugestoes: string[] } {
  if (['time', 'calendar', 'tracker'].includes(section)) return { titulo: 'Assistente · Tempo', sugestoes: TEMPO };
  if (SECOES_PROJETOS.includes(section)) return { titulo: 'Assistente · Projetos', sugestoes: PROJETOS };
  if (section === 'price-simulator') return { titulo: 'Assistente · Propostas', sugestoes: PROPOSTAS };
  if (isAdmin && ['reports', 'nankin-insights'].includes(section)) {
    return { titulo: 'Assistente · Relatórios', sugestoes: RELATORIOS };
  }
  return { titulo: 'Assistente', sugestoes: TEMPO };
}

// Grupo do catálogo que combina com o bloco aberto (abre por padrão no painel).
export function grupoDoBloco(section: string): string | null {
  if (['time', 'calendar', 'tracker'].includes(section)) return 'Suas horas';
  if (SECOES_PROJETOS.includes(section)) return 'Projetos e tarefas';
  if (section === 'price-simulator') return 'Propostas';
  if (['reports', 'nankin-insights'].includes(section)) return 'Equipe e receita';
  return null;
}
